<template>
  <div class="item-list__item-wrapper">
    <div
      class="item-of-list"
      :class="{
        'item-of-list--todelete': isCandidateDelete,
        'item-of-list--canceled': review.isCancel,
        'father-item': hasChilds(),
      }"
    >
      <div class="expanded-buttons" v-if="!isChild">
        <button
          v-b-toggle="'child-items-list-' + review.id"
          @click="changeValueOfExpanded()"
          v-if="!isChild && review.reviewChildList.length != 0"
        >
          <BIconChevronRight
            font-scale="1.2"
            style="color: #747474"
            v-if="!verifyIfChangeValueOfExpanded"
          />
          <BIconChevronDown
            font-scale="1.2"
            style="color: #747474"
            v-if="verifyIfChangeValueOfExpanded"
          />
        </button>
      </div>
      <button
        class="item-list__item session-list-item-content"
        v-b-toggle="'sidebar-right-' + review.id"
      >
        <div class="item-list__item-details">
          <!--Nombre y organizador de la revision-->
          <div class="item-name">
            <div class="name">
              <span class="name">
                {{ review.title }}
              </span>
            </div>
            <div class="description">
              {{ $t("reviews.reviewBy") }} {{ review.organizerName }}
            </div>
          </div>
          <!--Fecha Inicio-->
          <div class="item-start-date">
            <div class="name">
              <span class="name">
                {{ $t("reviews.initDateTitle") }}
              </span>
            </div>
            <div class="description">
              {{ formattedStart(review.startDate) }}
            </div>
          </div>
          <!--Fecha Fin-->
          <div class="item-end-date">
            <div class="name">
              <span class="name">
                {{ $t("reviews.endDateTitle") }}
              </span>
            </div>
            <div class="description">
              {{ formattedEnd(review.endDate) }}
            </div>
          </div>
          <!--Estado-->
          <div class="item-date">
            <div class="name">
              <span class="">{{ $t("reviews.state") }}</span>
            </div>
            <div class="date">
              <span class="date">
                <span v-if="isOngoing(review)">
                  <span
                    class="session-ongoing d-flex gap-2 align-items-center"
                    v-if="review.endDate"
                  >
                    <b-icon-circle-fill class="icon-onGoing" />
                    {{ $t("reviews.inprogress") }}
                  </span>
                </span>
                <span v-if="!isOngoing(review)">
                  <span
                    class="session-not-started d-flex gap-2 align-items-center text-cancel"
                    v-if="review.isCancel"
                  >
                   <b-icon-circle-fill class="icon-cancel" />
                    {{ $t("reviews.isCanceled") }}
                  </span>
                  <span
                    class="session-not-started d-flex gap-2 align-items-center"
                    v-else-if="notYetStarted(review) && review.endDate"
                  >
                     <b-icon-circle-fill class="icon-notStarted" />
                    {{ $t("reviews.notstarted") }}
                  </span>
                  <span
                    class="session-not-started d-flex gap-2 align-items-center"
                    v-else-if="hasEnded(review)"
                  >
                    <b-icon-circle-fill class="icon-finalized" />
                    <span class="session-ended">
                      {{ $t("reviews.finished") }}
                    </span>
                  </span>
                </span>
              </span>
            </div>
          </div>
        </div>
      </button>
      <!-- <div class="chekbox_delete" v-if="isChild && adminRole">
          <b-form-checkbox
            v-model="checked"
            :disabled="!notYetStarted(review)"
            @change="changeIsCandidateDelete(review)"
          >
          </b-form-checkbox>
        </div> -->
      <div
        class="item-list__item-controls"
        :id="'options-' + review.id"
        v-if="adminRole"
      >
        <b-tooltip
          :target="'options-' + review.id"
          placement="left"
          triggers="hover"
        >
          {{ notYetStarted(review) ? $t("tool.enabled") : $t("tool.disabled") }}
        </b-tooltip>
        <b-dropdown
          right
          menu-class="button-list-icons small-icons list"
          variant="session-row-options has-tooltip"
          toggle-class="text-decoration-none"
          no-caret
          :disabled="!notYetStarted(review)"
        >
          <template #button-content v-if="adminRole">
            <dots-vertical-icon
              :id="'review-options-' + review.id"
              :size="24"
              focusable="false"
              fill-color="#080808"
              fillColor="#080808"
            />
          </template>
          <b-dropdown-item-btn
            v-if="!review.isCancel"
            link-class="button"
            v-b-toggle.sidebar="`sidebar-edit-${review.id}`"
          >
            <span>{{ $t("reviews.editconfig") }}</span>
          </b-dropdown-item-btn>
          <b-dropdown-item-btn
            v-if="!review.isCancel"
            link-class="button"
            @click="cancelReview(review)"
          >
            <span>{{ $t("reviews.cancel") }}</span>
          </b-dropdown-item-btn>
          <b-dropdown-item-btn
            v-if="review.isCancel"
            link-class="button"
            @click="recoverReview(review)"
          >
            <span>{{ $t("reviews.recover") }}</span>
          </b-dropdown-item-btn>
          <b-dropdown-item-btn
            v-if="!review.isCancel"
            link-class="button"
            v-b-modal="`delete-confirm-${review.id}`"
            @click="childConfirmDelete(review)"
          >
            <span>{{ $t("reviews.deletereview") }}</span>
          </b-dropdown-item-btn>
          <b-dropdown-item-btn
            v-if="!isChild && hasChildToDelete"
            link-class="button"
            v-b-modal="`delete-confirm-${review.id}`"
            @click="deleteSelectChild(review.id)"
          >
            <delete-outline-icon
              fill-color="#c23e37"
              class="svg-icon small default"
              :size="20"
            />
            <span>{{ $t("reviews.deleteMultipleFatherreview") }}</span>
          </b-dropdown-item-btn>
        </b-dropdown>
      </div>
    </div>
    <EditReviewSidebar
      v-if="!review.isCancel"
      @childInitReviews="childInitReviews"
      :review="review"
      :groups="groups"
    >
    </EditReviewSidebar>
    <info-review-sidebar
      v-if="!review.isCancel"
      :review="review"
      :adminRole="adminRole"
      :groups="groups"
    />
  </div>
</template>
<script>
import ServiceReviews from "@/service/review.js";
import DateService from "@/service/dates.js";
import DotsHorizontalIcon from "vue-material-design-icons/DotsHorizontal.vue";
import DotsVerticalIcon from "vue-material-design-icons/DotsVertical.vue";

import InfoReviewSidebar from "@/components/Lti/Modals/InfoReviewSidebar";
import DeleteOutlineIcon from "vue-material-design-icons/DeleteOutline";
import jwtMixin from "@/mixins/jwtMixin.js";
import utilitiesMixin from "@/mixins/utilitiesMixin";
import EditReviewSidebar from "@/components/Lti/Modals/EditReviewSidebar.vue";
import PencilOutlineIcon from "vue-material-design-icons/PencilOutline.vue";
import {
  BIconChevronRight,
  BIconChevronDown,
  BIconXCircleFill,
  BIconCalendar2CheckFill,
  BIconFunnel,
  BIconCircleFill,
} from "bootstrap-vue";

export default {
  name: "reviewItem",
  components: {
    // eslint-disable-next-line vue/no-unused-components
    DotsHorizontalIcon,
    DotsVerticalIcon,
    DeleteOutlineIcon,
    InfoReviewSidebar,
    EditReviewSidebar,
    // eslint-disable-next-line vue/no-unused-components
    PencilOutlineIcon,
    BIconChevronRight,
    BIconChevronDown,
    // eslint-disable-next-line vue/no-unused-components
    BIconXCircleFill,
    // eslint-disable-next-line vue/no-unused-components
    BIconFunnel,
    BIconCircleFill,
    // eslint-disable-next-line vue/no-unused-components
    BIconCalendar2CheckFill,
  },
  mixins: [jwtMixin, utilitiesMixin],
  props: [
    "review",
    "isChild",
    "isExpand",
    "groups",
    "adminRole",
    "listToDelete",
  ],
  data: function () {
    return {
      user_roles: [],
      user_id: "",
      expanded: true,
      isCandidateDelete: false,
      startDateSignup: null,
      endDateSignup: null,
      userTimezone: DateService.getUserTimezone(),
    };
  },
  async created() {
    this.user_roles = this.jwtLoggedUserRole();
    this.user_id = this.jwtLoggedUserId();

    const startMoment = this.getStartMomentUtc();
    this.startDateSignup = this.subtractFromStart(
      startMoment,
      this.review.signupStartNumber,
      this.review.signupStartUnit
    );
    this.endDateSignup = this.subtractFromStart(
      startMoment,
      this.review.signupEndNumber,
      this.review.signupEndUnit
    );
  },
  methods: {
    getStartMomentUtc() {
      return window.moment.utc(this.review.startDate);
    },
    subtractFromStart(startMoment, number, unit) {
      let plusUnit = null;
      if (parseInt(unit) === 1) plusUnit = "m";
      if (parseInt(unit) === 2) plusUnit = "h";
      if (parseInt(unit) === 3) plusUnit = "d";
      return startMoment
        .clone()
        .subtract(parseInt(number), plusUnit)
        .utc()
        .format("YYYY-MM-DD[T]HH:mm:ss[Z]");
    },
    formattedStart(dateUtc) {
      return DateService.utcToEvent(
        dateUtc,
        this.userTimezone,
        "D/M/YY - HH:mm"
      );
    },
    formattedEnd(dateUtc) {
      return DateService.utcToEvent(
        dateUtc,
        this.userTimezone,
        "D/M/YY - HH:mm"
      );
    },
    hasChilds() {
      return !this.isChild && this.review.reviewChildList.length != 0;
    },
    childConfirmDelete(review) {
      this.$emit("confirmDelete", review);
    },
    childInitReviews() {
      this.$emit("initReviews");
    },
    changeValueOfExpanded() {
      this.expanded = !this.expanded;
    },
    changeIsCandidateDelete(review) {
      this.$emit("selectChildToDelete", review);
      this.isCandidateDelete = !this.isCandidateDelete;
    },
    deleteSelectChild(reviewId) {
      this.$emit("deleteSelectChild", reviewId);
    },
    cancelReview(review) {
      review.isCancel = true;
      ServiceReviews.putReview(review.id, review).then((response) => {
        if (response && response.status === 200) {
          this.$noty.success(this.$t("reviews.success-cancel"), {
            timeout: 3000,
            progressBar: true,
          });
        } else {
          this.$noty.error(this.$t("reviews.error-cancel"), {
            timeout: 3000,
            progressBar: true,
          });
        }
      });
    },
    recoverReview(review) {
      review.isCancel = false;
      ServiceReviews.putReview(review.id, review).then((response) => {
        if (response && response.status === 200) {
          this.$noty.success(this.$t("reviews.success-recover"), {
            timeout: 3000,
            progressBar: true,
          });
        } else {
          this.$noty.error(this.$t("reviews.error-recover"), {
            timeout: 3000,
            progressBar: true,
          });
        }
      });
    },
  },
  computed: {
    verifyIfChangeValueOfExpanded() {
      return this.expanded;
    },
    hasChildToDelete() {
      let rst = this.review.reviewChildList.filter((rev) =>
        this.listToDelete.includes(rev)
      );
      return rst.length > 0;
    },
  },
};
</script>
